import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callouts: {
      dataInfo: {
        title:
          'Track your finances for 2023 right away. Earlier data is coming in the next few weeks.',
      },
    },
    infoBlocks: {
      analyzeVariations: {
        subtitle: 'Specify a date range and keep track of your finances.',
        title: 'Analyze your cash flow, month by month',
      },
      feedback: {
        subtitle: 'Give your feedback and help us improve the interface',
        subtitleNext: 'by clicking here.',
        title: 'Give us your feedback on the feature',
      },
      financeDetail: {
        subtitle:
          'Filter your cash inflows and outflows by merchant or transaction type.',
        title: 'Check the details of your finances',
      },
    },
    mainCTA: 'Discover the feature',
    subtitle:
      'Get exclusive access to this new feature and actively participate to its improvement',
    welcomeToDashboard: 'Welcome to your cash flow analysis interface!',
  },
  fr: {
    callouts: {
      dataInfo: {
        title:
          "Suivez dès aujourd'hui vos finances sur toute l'année 2023. Les données antérieures arrivent dans les prochaines semaines.",
      },
    },
    infoBlocks: {
      analyzeVariations: {
        subtitle:
          'Spécifiez une plage de date et suivez l’évolution de vos finances.',
        title: 'Analysez les variations de votre trésorerie, mois après mois',
      },

      feedback: {
        subtitle:
          'Faites-nous vos retours et participez à l’amélioration de l’interface',
        subtitleNext: 'en cliquant ici.',
        title: 'Faites-nous vos retours sur la fonctionnalité',
      },
      financeDetail: {
        subtitle:
          'Filtrez vos entrées et sorties d’argent par marchand ou type d’opération.',
        title: 'Entrez dans le détail de vos finances',
      },
    },
    mainCTA: 'Découvrir la fonctionnalité',
    subtitle:
      'Profitez en exclusivité de cette nouvelle fonctionnalité et participez à son amélioration.',
    welcomeToDashboard: 'Bienvenue dans votre Tableau de bord !',
  },
} as const);

export default locales;
